import React, { Component } from 'react';
import propTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { Button } from '@heroui/react';
import { HeadingFG } from '../../../../cra/src/styling/theme';
import {
  Close,
  Help,
} from '../../../../cra/src/components/userDocuments/editDocument/editJournal/toolset/assets/icons';
import Lock from '../../../../cra/src/components/userDocuments/editDocument/UI/Editor/Toolbar/CenterToolbar/lock';
import Download from '../../../../cra/src/components/userDocuments/editDocument/editResume/Toolbar/ToolbarItems/download';
import { FormatTypes } from '../../../../cra/src/constants/templateDictionaries';
import getUserPlan from '../../../../cra/src/components/userDocuments/editDocument/editResume/getUserPlan';
import { Tooltip } from '../../../../cra/src/components/userDocuments/editDocument/UI/Editor/MostUsedToolset/tooltip';
import ImportDocument from '../../../../cra/src/components/userDocuments/editDocument/editResume/importDocument/ImportDocument';
import GenerateCoverLetter from '../../../../cra/src/components/userDocuments/editDocument/editResume/generateCoverLetter/generateCoverLetter';
import breakpointsMinWidth from '../../../../cra/src/styling/breakpointsMinWidth';

const TextWrapper = styled.div`
  cursor: pointer;
  color: ${HeadingFG};
  font-size: 12px;

  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;
const InnerText = styled.div`
  padding: 4px 6px;
  border-radius: 4px;
  &:hover {
    background: rgba(162, 162, 162, 0.13);
  }
`;
class ImageItem extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  onClick = (e) => {
    const {
      listItem: { icon, triggerFunction },
      activePlan,
      subscriptionStatus,
      formatType,
      selectedPlan,
    } = this.props;
    e.preventDefault();

    const userType = getUserPlan(activePlan, subscriptionStatus, selectedPlan);

    if (
      icon === 'download-editor' &&
      userType === 'free' &&
      formatType === FormatTypes.COVER_LETTER
    )
      return;
    if (triggerFunction) {
      triggerFunction();
    }
  };

  render() {
    const {
      listItem: { icon, text, toolTip, childrenList, dropdownName },
      formatType,
      saveStatus,
      appType,
      templateType,
      selectedPlan,
    } = this.props;
    const { upgradeMessage } = this.state;

    return (
      <div className="relative h-full flex items-center">
        {
          {
            Save: (
              <SaveToolbar handleClick={this.onClick} saveStatus={saveStatus} />
            ),
            Share: (
              <TextWrapper onClick={this.onClick} aria-label="Share">
                <InnerText>{text}</InnerText>
              </TextWrapper>
            ),
            'download-editor': (
              <Download
                formatType={formatType}
                upgradeMessage={upgradeMessage}
                text={text}
                appType={appType}
                childrenList={childrenList}
                dropdownName={dropdownName}
                templateType={templateType}
                selectedPlan={selectedPlan}
              />
            ),
            'close-editor': (
              <CloseEditor handleClick={this.onClick} toolTip={toolTip} />
            ),
            help: <Help />,
            lock: <Lock />,
            'import-document': <ImportDocument text={text} />,
            'generate-cover-letter': (
              <GenerateCoverLetter formatType={formatType} text={text} />
            ),
          }[icon]
        }
      </div>
    );
  }
}

ImageItem.propTypes = {
  listItem: propTypes.shape({
    type: propTypes.string,
    icon: propTypes.string,
  }),
  saveStatus: propTypes.bool.isRequired,
};

ImageItem.defaultProps = {
  listItem: {
    type: '',
    icon: '',
  },
};

export default ImageItem;

const fadeIn = keyframes`
from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

const CloseWrapper = styled.div`
  position: relative;
  cursor: pointer;
  &:hover {
    div {
      display: block;
      animation: ${fadeIn} 0.2s ease-in;
    }
  }
`;
const SavedText = styled.span`
  position: relative;
`;

export const CloseEditor = ({ toolTip, handleClick }) => {
  return (
    <CloseWrapper onClick={handleClick} aria-label="Close editor">
      <Close fill="black" width="20px" height="20px" />
      <Tooltip top="42px" renderTooltip="end">
        {toolTip}
      </Tooltip>
    </CloseWrapper>
  );
};

export const SaveToolbar = (props) => {
  const { saveStatus, handleClick } = props;

  return (
    <Button
      onClick={handleClick}
      saveStatus={saveStatus}
      color={saveStatus ? 'default' : 'primary'}
      size="sm"
      className="text-[12px] desktopMd:text-[14px]"
    >
      {
        {
          true: (
            <>
              <SavedText>Saved</SavedText>
            </>
          ),
          false: (
            <SavedText className="saveTextEditor" aria-label="Save document">
              <SavedText>Save</SavedText>
              <sup>*</sup>
            </SavedText>
          ),
          saving: <SavedText>Saving...</SavedText>,
        }[saveStatus]
      }
    </Button>
  );
};
